"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _emailUtils = require("../../../../utils/emailUtils");
var _Partner = require("../../contexts/Partner");
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Container = _interopRequireDefault(require("../Container"));
var _Button = _interopRequireDefault(require("../common/Button"));
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ConfirmEmail = function ConfirmEmail(_ref) {
  var link = _ref.link;
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    isWl = _useContext.isWl,
    partnerName = _useContext.name;
  var styles = {
    container: {
      textAlign: 'center'
    },
    offset: {
      padding: '0 20px'
    },
    title: {
      fontSize: '26px',
      fontWeight: 500,
      color: _userflow["default"].colors.black
    },
    description: {
      fontSize: '19px',
      color: _userflow["default"].colors.blackBase
    },
    info: {
      fontSize: '16px',
      color: _userflow["default"].colors.greyLight
    },
    buttonWrapper: {
      backgroundColor: _userflow["default"].colors.white,
      textAlign: 'center'
    },
    buttonTitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: _userflow["default"].colors.black
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container,
    fullWidth: true,
    bgColor: "#fff",
    className: "offer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.offset
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 25
  }), /*#__PURE__*/_react["default"].createElement(Title, {
    style: styles.title
  }, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435", /*#__PURE__*/_react["default"].createElement("br", null), "\u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.buttonWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    width: 146,
    height: 43,
    link: link
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: styles.buttonTitle
  }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 22
  })), !isWl && /*#__PURE__*/_react["default"].createElement(Description, {
    style: styles.description
  }, "\u0412 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F", /*#__PURE__*/_react["default"].createElement("br", null), "\u043E\u0442 \u043D\u0430\u0448\u0438\u0445 \u043F\u0438\u0441\u0435\u043C, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0441\u0441\u044B\u043B\u043A\u0443 \u0432\u043D\u0438\u0437\u0443 \u043F\u0438\u0441\u044C\u043C\u0430"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 10
  }), /*#__PURE__*/_react["default"].createElement(Info, {
    style: styles.info
  }, "\u0415\u0441\u043B\u0438 \u0432\u044B \u043D\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C \u043D\u0430 ".concat(partnerName, ", \u043F\u0440\u043E\u0441\u0442\u043E \u043F\u0440\u043E\u0438\u0433\u043D\u043E\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u044D\u0442\u043E \u043F\u0438\u0441\u044C\u043C\u043E."), "\u0421\u043A\u043E\u0440\u0435\u0435 \u0432\u0441\u0435\u0433\u043E \u043A\u0442\u043E-\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043B \u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u043F\u043E-\u043E\u0448\u0438\u0431\u043A\u0435"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 56
  })));
};
ConfirmEmail.propTypes = {
  link: _propTypes["default"].string.isRequired
};
var Title = _styledComponents["default"].div.withConfig({
  displayName: "ConfirmEmail__Title",
  componentId: "sc-1g3rn76-0"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 20px !important;\n  "]))));
var Description = _styledComponents["default"].div.withConfig({
  displayName: "ConfirmEmail__Description",
  componentId: "sc-1g3rn76-1"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 16px !important;\n  "]))));
var Info = _styledComponents["default"].div.withConfig({
  displayName: "ConfirmEmail__Info",
  componentId: "sc-1g3rn76-2"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 14px !important;\n  "]))));
var _default = exports["default"] = ConfirmEmail;